<template>
  <el-select class="select-default segment-autcomplete"
             :name="name"
             :placeholder="$t('generic.searchSegments')"
             filterable
             clearable
             :value="value"
             v-bind="$attrs"
             v-on="listeners">
    <i slot="prefix" class="nc-icon nc-tile-56"></i>
    <el-option-group v-for="(groupSegments, groupName) in segments"
                     :key="groupName"
                     :label="groupName.toUpperCase()">
      <el-option class="select-default"
                 v-for="segment in groupSegments"
                 :key="segment.id"
                 :label="segment.value"
                 :value="segment.id">
      </el-option>
    </el-option-group>
  </el-select>
</template>

<script>
  import { Select, Option, OptionGroup } from 'element-ui';

  export default {
    name: 'segment-autocomplete',
    inheritAttrs: false,
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [OptionGroup.name]: OptionGroup,
    },
    props: {
      name: String,
      value: [String, Array, Number]
    },
    computed: {
      listeners() {
        return {
          ...this.$listeners,
          change: this.onChange
        }
      },
      segments() {
        return this.$store.state.config.segments
      }
    },
    methods: {
      onChange(val) {
        this.$emit('change', val);
      }
    }
  }
</script>

<style lang="scss">
  .segment-autcomplete {
    width: 100%;
    .el-input__prefix {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
